import { render } from "./ModuleInfo.vue?vue&type=template&id=494a1ab2&scoped=true&ts=true"
import script from "./ModuleInfo.vue?vue&type=script&lang=ts"
export * from "./ModuleInfo.vue?vue&type=script&lang=ts"

import "./ModuleInfo.vue?vue&type=style&index=0&id=494a1ab2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494a1ab2"]])

export default __exports__